import { DataErrorOccurredInfo, GridBase } from "devextreme/common/grids";
import { EventInfo } from "devextreme/events";
import { alert } from 'devextreme/ui/dialog';
import notify from "devextreme/ui/notify";
import { ResponseError } from "../data";

export function dataGridErrorHandling(e: EventInfo<GridBase> & DataErrorOccurredInfo) {
  console.log(e);
  if (e.error?.cause) {
    alert((e.error as any).cause.message, "Errore");
  }
  else if ((e.error as any).response) {
    var response = ((e.error as any).response as Response);

    if (response.status == 403) {
      if (response.statusText)
        alert(response.statusText, "Errore");
      else
        alert("Autorizzazione non valida per questa operazione", "Errore");
    }
    else
      return response.json()
        .then(function (data) {
          console.log(data);
          if (data.title) {
            let text: string = data.title + " <br>";

            if (data.errors) {
              for (var key in data.errors) {
                text += data.errors[key] + " <br>";
              }
            }

            alert(text, "Errore");
          }
          else
            alert(data, "Errore");
        });
  }
}

export function showError(e: Error | ResponseError | any) {
  if (e instanceof ResponseError) {
    const contentType = e.response.headers.get('Content-Type');

    if (contentType && contentType.includes('application/json')) {
      e.response.json().then((errorBody) => {
        const message = errorBody.message || JSON.stringify(errorBody);
        alert(message,"Errore");
      }).catch(() => {
        alert('Errore nel parsing della risposta JSON',"Errore");
      });
    } else {
      e.response.text().then((text) => {
        alert(text || 'Errore sconosciuto dal server',"Errore");
      });
    }
  }

  else if (e?.message) {
    alert(e.message, "Errore");
  }
  else if (e?.cause) {
    alert((e as any).cause.message, "Errore");
  }
  else if ((e as any).response) {
    var response = ((e as any).response as Response);
    if (response.status == 403) {
      if (response.statusText)
        alert(response.statusText, "Errore");
      else
        alert("Autorizzazione non valida per questa operazione", "Errore");
    }
    else
      return response.json()
        .then(function (data) {
          console.log(data);
          if (data.title) {
            let text: string = data.title + " <br>";

            if (data.errors) {
              for (var key in data.errors) {
                text += data.errors[key] + " <br>";
              }
            }

            alert(text, "Errore");
          }
          else
            alert(data, "Errore");
        });
  }
}

export function notifyError(e: Error | any) {
  if (e?.cause) {
    notify((e as any).cause.message, "Errore", 2000);
  }
  else if ((e as any).response) {
    var response = ((e as any).response as Response);
    if (response.status == 403) {
      if (response.statusText)
        notify(response.statusText, "Errore", 2000);
      else
        notify("Autorizzazione non valida per questa operazione", "Errore", 2000);
    }
    else
      return response.json()
        .then(function (data) {
          console.log(data);
          if (data.title) {
            let text: string = data.title + " <br>";

            if (data.errors) {
              for (var key in data.errors) {
                text += data.errors[key] + " <br>";
              }
            }

            notify(text, "Errore", 2000);
          }
          else
            notify(data, "Errore", 2000);
        });
  }
}